import React from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../Services/translation';

const CreditOrderHistoryList = ({
    onShowDetail,
    isBusinessCustomer
}) => {
    const orders = useSelector((state) => state.myPage.creditOrders.list);
    return (
        <div className="order-history__list">
            {orders?.length > 0 && (
                <div className="order-table__container  simple-table">
                    <div className="row medium-unstack no-margin order-table__header">
                        <div className=" order-table__header--cell">
                            {translate('orderlist.column.orderdate')}
                        </div>
                        <div className=" order-table__header--cell">
                            {translate('orderlist.column.ordernumber')}
                        </div>
                        <div className=" order-table__header--cell">
                            {translate('orderlist.column.marking')}
                        </div>
                        <div className=" order-table__header--cell">
                            {translate('orderlist.column.content')}
                        </div>
                        <div className=" order-table__header--cell">
                            {translate('orderlist.column.grandtotal')}
                        </div>
                    </div>
                    {orders &&
                        orders.map((order) => (
                            <div
                                key={order.orderId}
                                className="row medium-unstack no-margin order-table__rows"
                            >
                                <div className="order-table__cell">{order.orderDate}</div>
                                <div className="order-table__cell">
                                    <a
                                        onClick={() => onShowDetail(order)}
                                        className="order-detail__product-link"
                                    >
                                        {order.externalOrderID}
                                    </a>
                                </div>
                                <div className="order-table__cell">
                                    <span className="order-table__cell--mark">{order.note}</span>
                                </div>
                                <div className="order-table__cell">
                                    <a
                                        onClick={() => onShowDetail(order)}
                                        className="order-detail__product-link"
                                    >
                                        {order.orderRows[0]?.brand}
                                        <b>{order.orderRows[0]?.name}</b>&nbsp;
                                        {order.orderRows.length > 1 &&
                                            translate(
                                                order.orderRows.length > 2
                                                    ? 'orderlist.items'
                                                    : 'orderlist.item'
                                            ).replace('{0}', order.orderRows.length - 1)}
                                    </a>
                                </div>
                                <div className="order-table__cell">{order.orderGrandTotal}</div>
                            </div>
                        ))}
                </div>
            )}
            {orders?.length <= 0 && <div>{translate('code.mypage.creditorderlist.noorderfound')}</div>}
        </div>
    );
};

export default CreditOrderHistoryList;